import { formatDate, FormattedDate } from "common/helpers";
import { useSelector } from "react-redux";
import paymentSelectors from "store/selectors/payments";

export interface PaymentInfoPropsHook {
  updatedAt: FormattedDate;
  createdAt: FormattedDate;
}

export default function usePaymentInfoProps(): PaymentInfoPropsHook {
  const payment = useSelector(paymentSelectors.getEntity);
  const updatedAt = formatDate(payment?.metadata?.updated_at);
  const createdAt = formatDate(payment?.metadata?.created_at);

  return {
    updatedAt,
    createdAt,
  };
}
